<template>
  <div class="app">
    <Card dis-hover>
	  <Form ref="queryForm" :label-width="60" label-position="left" inline>
	      <Row :gutter="20">
	          <Col span="5">
	             <FormItem label="用户名：" :label-width="70" >
	               <Input type="text" placeholder="请输入" v-model="form.name" style="width:200px"></Input>
	             </FormItem>
	          </Col>
			  <Col span="5">
			      <FormItem label="年份:" :label-width="50" style="width: 100%">
			         <DatePicker
			           type="year"
			           @on-change="(fmtDate,date)=>{changeDate(fmtDate,date,'year')}"
			           :value="form.year"
			           placeholder="请选择"
			           :editable="false"
			           style="width:200px; "
			         ></DatePicker>
			      </FormItem>
			  </Col>
			  <Col span="5">
			      <!-- <FormItem label="月份:" :label-width="50" style="width: 100%">
			         <DatePicker
			           type="month"
			           @on-change="(fmtDate,date)=>{changeDate(fmtDate,date,'month')}"
			           :value="form.month"
					   format="MM"
			           placeholder="请选择"
			           :editable="false"
			           style="width:200px; "
			         ></DatePicker>
			      </FormItem> -->
				  <FormItem label="月份:" :label-width="80">
				    <Select placeholder="请选择月份"  style="width: 180px" v-model="form.month">
				  	<Option value="1">1月</Option>
				  	<Option value="2">2月</Option>
				  	<Option value="3">3月</Option>
				  	<Option value="4">4月</Option>
				  	<Option value="5">5月</Option>
				  	<Option value="6">6月</Option>
				  	<Option value="7">7月</Option>
				  	<Option value="8">8月</Option>
				  	<Option value="9">9月</Option>
				  	<Option value="10">10月</Option>
				  	<Option value="11">11月</Option>
				  	<Option value="12">12月</Option>
				    </Select>
				  </FormItem>
			  </Col>
			  <Col span="5">
			  	<FormItem label="部门:" :label-width="50" style="width: 100%"><!--  multiple -->
			  		<selectTree style="width:200px; " v-model="form.organizationUnitId"  :treeData="treeData" @on-select-change="selectChange" @on-remove="removeRoot" :showQuery='false' ></selectTree>
			  	</FormItem>
			  </Col>
			  </Row>
			  <Row :gutter="20">
				  <Col span="5">
				     <FormItem label="事业部:" :label-width="70" >
				       <Input type="text" placeholder="请输入" v-model="form.causeDepartment" style="width:200px"></Input>
				     </FormItem>
				  </Col>
				  <Col span="5">
				  <FormItem label="岗位:" :label-width="50" style="width: 100%">
				    <Select placeholder="请选择岗位"  style="width: 200px" v-model="form.post">
				      <Option value="">------</Option>
				      <Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.name }}</Option>
				    </Select>
				  </FormItem>
				  </Col>
				  <Button icon="ios-search" type="primary" size="default" @click="getData(1)" class="toolbar-btn">查询</Button>
				  <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
				  <Button type="success" icon="md-archive" @click="importT" class="toolbar-btn">导入</Button>&nbsp;&nbsp;
				  <Button icon="md-archive" type="primary" size="default" @click="downLoadTemplate" class="toolbar-btn">下载导入模板</Button>
			  </Row>
	          
			  <!-- <Button type="success" icon="md-archive" @click="deleteImport" class="toolbar-btn">清空</Button>&nbsp;&nbsp; -->
			 <!-- <Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile" :headers="requestHeader" accept=".xlsx,.xls,.excel" :show-upload-list="false" :action="action" :data="importData">
			      <Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入数据</Button>
			  </Upload> -->
	  </Form>
      <div class="table_body" >
        <Table
            ref="table"
            border
            :loading="loading"
            :columns="columns"
            :no-data-text="NoDatas"
            :data="tableBody_item"
          ></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
      </div>
    </Card>
    <!-- 新增/编辑弹出框 -->
     <newdate-table :value="testModal" :type='modelType' @close="close" ref="newID"></newdate-table>
     <!-- 导入 -->
     <dateImport :value="testDate"  @close="closeDate" ref="importDay"></dateImport>
     <!-- 操作日志弹出框 -->
     <operation :value="testLog"  @close="closeLog" ref="logID"></operation>
     <!-- 清空 -->
     <deleteImport :value="showDelete"  @close="closeDate" ref="deleteImport"></deleteImport>
     
  </div>
</template>
<script>
import Util from '../../../lib/util';
import moment from "moment";
import newdateTable from './newdateTable.vue'
import dateImport from './dateImport.vue'
import deleteImport from './delete.vue'
import operation from './operation.vue'
import selectTree from '../../../components/selectTree/selectTree.vue'
import {
  getAttendanceListData
} from '../../../api/index'

export default {
  name:'personholiday',
  props: {},
  components:{
    newdateTable,
    dateImport,
	deleteImport,
    operation,
	selectTree
  },
  filters: {
    formData(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      totalCount:0, //总共多少页
	  currentPage: 1,
      testModal:false,
      testDate:false,
	  showDelete:false,
      testLog:false,
      form: {
        "name": "",
		"month":"",
		"year":"",
		"post":null,
		"causeDepartment":"",
		"organizationUnitId":null,
        "MaxResultCount": 10,
        "SkipCount": 0,
		"IncludeLeaveUser":true
      },
	  pageSize: 10,
      NoDatas: "暂无数据",
	  action: this.$constDefinition.baseUrl + '/Leavefile/Upload',
	  spinShow: false,
	  importData: {},
	  requestHeader: {
	      Authorization: `Bearer ${Util.abp.auth.getToken()}`,
	  },
      loading: false,
      columns:  [
		  {
		    title: "姓名",
		    key: "name",
			render: (h, params) => {
			  return h("span", params.row.leaveUser.name);
			},
		  },
        {
          title: "事业部",
          key: "causeDepartment",
          render: (h, params) => {
            return h("span", params.row.leaveUser.causeDepartment);
          },
        },
        {
          title: "部门",
          key: "departmentText",
        },
        {
          title: "岗位",
          key: "postText",
          render: (h, params) => {
            return h("span", params.row.leaveUser.postText);
          },
        },
        {
          title: "年份",
          key: "year",
        },
        {
          title: "月份",
          key: "month",
        },
        {
          title: "考勤明细",
          align: "center",
          children: [
            { title: "合计", key: "sumCount" },
            { title: "迟到", key: "lateCount" },
            { title: "早退", key: "earlyLeaveCount" },
            { title: "未打卡", key: "noClockInCount" },
            { title: "旷工", key: "absenteeismCount" },
            { title: "其他", key: "otherCount" },
          ]
        },
		{
		  title: "操作",
		  key: "Actions",
		  width: 150,
		  align: 'center',
		  render: (h, params) => {
		    return h("div", [
		      h(
		        "Button",
		        {
		          props: {
		            type: "error",
		            size: "small",
		          },
		          on: {
		            click: async () => {
		              this.$Modal.confirm({
		                title: "提示",
		                content: "是否确认删除？",
		                okText: "是",
		                cancelText: "否",
		                onOk: async () => {
		                  await this.$Ajax.delete(`/api/services/app/AttendanceRecord/Delete?id=${params.row.id}`);
		                    this.getData()
		                    this.$Message.success('操作成功!');
		                },
		              });
		            },
		          },
		        },
		        "删除"
		      ),
		    ]);
		  },
		},
      ],
	  postList:[],
	  treeData:[],
      tableBody_item: [],
      fromFields: {},
      modelType: '新增'

    };
  },
  mounted() {
    this.getTree()
	this.getSelectList();
	this.changeDates()
	this.getData()
    // this.getColumns(); //列表数据初始化
  },
  methods: {
	  changeDates() {
	    this.form.month = this.$moment(this.form.Month).format("MM") 
	    this.form.year = this.$moment(this.form.Month).format("YYYY") 
	  },
	  //时间转换
	  changeDate(fmtDate,date,type) {
		  // console.log(this.$moment(this.form[type]).format("MM") );
		  // console.log(this.$moment(this.form.year).format("yyyy") );
	    this.form[type] = fmtDate//this.$moment(this.form.month).format("MM") 
		console.log(this.form);
	   //  this.form.year = this.$moment(this.form.year).format("yyyy") 
	  },
	
	//分页
	pageChange(page) {
	  this.currentPage = page
	  this.getpage()
	},
    //每页最大条数
    pagesizeChange(size){
      this.form.MaxResultCount = size
      this.getData()
    },
	reset() {
            // 清空所有属性值
            Object.keys(this.form).forEach(key => (this.form[key] = ''));
			this.form.post=null;
			this.changeDates()
            // this.rangeTime = [];
        },
    //列表数据
    async getData(params) {
		this.form.MaxResultCount = this.pageSize
		this.form.SkipCount = (this.currentPage - 1) * this.pageSize
		if (params === 1) {
		  this.form.SkipCount = 0
		}
		this.loading = true
		const res = await getAttendanceListData(this.form)
		this.tableBody_item = res.data.result.items
		this.totalCount = res.data.result.totalCount
		this.loading = false
    },
	// 下载导入模板
	downLoadTemplate() {
	    this.downloadFile('/Leavefile/DownloadModel_Attendance', '导入考勤信息模板');
	},
	selectChange(data){
		this.form['organizationUnitId'] = data
	},
	removeRoot(data){
		this.form['organizationUnitId'] = data
	},
	//获取下拉框
	async getSelectList() {
	  const { data } = await this.$Ajax.get(
	    '/api/services/app/AttendanceRecord/GetAttendanceRecordInitData'
	  )
	  this.postList = data.result.postList
	},
	async getTree(){
		let reponse = await this.$Ajax.get(
		  '/api/services/app/OrganizationUnit/GetOrganizationUnitTree'
		)
		console.log(reponse);
		let list=reponse.data.result
		this.editeTreeValue(list);
		this.treeData = list;
		console.log(this.treeData,"zzzz");
		this.$emit('postComponent',this);
	},
	editeTreeValue(data){
		for (let i=0; i<data.length; i++) {
			data[i].title = data[i].displayName
			data[i].value = data[i].id
			if(data[i].children){
				if(data[i].children.length>0){
				   data[i].expand=true
				}
				this.editeTreeValue(data[i].children)
			}
		}
	},
	downloadFile(url, title) {
	    const date = moment(new Date()).format('yyyyMMDDHHmm');
	    let _this = this;
	    let consturl = this.$constDefinition.baseUrl + url; //下载地址url
	    var xhr = new XMLHttpRequest();
	    xhr.open('get', consturl, true); // get、post都可
	    xhr.responseType = 'blob';
	    xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`); //加请求头
	    xhr.onload = function () {
	        console.log(xhr);
	        if (xhr.status == 200) {
	            let blob = new Blob([this.response], {
	                type: 'application/vnd.ms-excel',
	            });
	            var a = document.createElement('a');
	            var url = window.URL.createObjectURL(blob);
	            a.href = url;
	            a.download = title + date + '.xlsx'; // 文件名
	            if (xhr.readyState === 4) {
	                _this.$Message.success({
	                    content: '下载成功',
	                    duration:3
	                });
	            }
	        } else {
	            _this.$Message.error({
	                content: '下载失败',
	                duration:3
	            });
	        }
	        a.click();
	        window.URL.revokeObjectURL(url);
	    };
	    xhr.send();
	},
    //新增 
    listTest(type,data){
      this.modelType = type
      this.testModal = true;
      if(type=="编辑"){
        this.$refs.newID.getInforID(data.id)
      }
    },
    //关闭新增编辑弹出框
    close(data){
		this.testModal = false;
		if(data.cancel){
			this.getData();
		}
  },
  //下载模板
			down(e){
				window.open(abp.url+e)
			},
  //人员假期导入
    importT(){
  				this.testDate = true;
  				// this.$refs.uploads.clearn();
    },
	deleteImport(){
		this.showDelete=true;
	},
    closeDate(){
      this.testDate = false;
	  this.showDelete = false;
      this.form.skipCount = 0;
      this.getData();
    },
  // 导入前处理
  beforeImportFile() {
      this.spinShow = true;
  },
  // 导入成功
  importFile() {
      this.$Message.success({
          content: '导入成功',
          duration: 3,
      });
      this.getData();
      this.spinShow = false;
  },
  // 导入失败
  errorImportFile(error, file, fileList) {
      this.$Message.error({
          content: file.error.message,
          duration: 3,
      });
      this.getData();
      this.spinShow = false;
  },
    closeDate(){
      this.testDate = false;
      this.form.skipCount = 0;
      this.getData();
    },

    //打开日志弹出框
    openLog(type,data){
      this.testLog = true;
      this.$refs.logID.getLogID(data.id)
      
    },
    //关闭关闭弹出框
    closeLog(data){
		this.testLog = false;
		},
  
  },
};
</script>

<style lang="less" scoped="scoped">
.app{
min-width: 900px;

}
.ivu-upload {
    display: inline-block;
}
</style>
